/* import __COLOCATED_TEMPLATE__ from './new-phone-call.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();